export default __webpack_public_path__ + "static/media/cold-steamer.9bd8abea.png";